import axios from 'axios';
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { BACKEND_SERVER_URL } from '../../../http/http-config';
import { sortInAlphabeticalOrder, multiSortTopics } from '../common-helpers/commonServices';

const UGC_TestManagementModal = forwardRef((props, ref) => {
    const [modalBox, setModalBox] = useState(false);
    const [topics, setTopics] = useState([]);
    const [examType, setExamType] = useState('');
    const [assignedQuestions, setAssignedQuestions] = useState(0);
    const [questionLimit, setQuestionLimit] = useState(0);
    const [topicWiseSubjects, setTopicsWiseSubjects] = useState([]);
    const [combinedGATopics, setCombinedGATopics] = useState([]);
    const [selectedExam, setSelectedExam] = useState("GENERAL APTITUDE");

    console.log(topicWiseSubjects);
    console.log(combinedGATopics);

    const [subjectToDisplay, setSubjectToDisplay] = useState(null);


    useImperativeHandle(ref, () => ({
        openModal(item) {
            setExamType(item);
            setModalBox(true);
        }
    }));

    useEffect(() => {
        if (!examType || !modalBox) return
        const response = axios.all([
            axios.get(BACKEND_SERVER_URL + '/ugc/topics/' + (examType !== 'COMBINED' ? examType : '')),
            axios.get(BACKEND_SERVER_URL + '/ugc/assigned-quetions/' + examType),
            axios.get(BACKEND_SERVER_URL + '/ugc/quetion-limit/' + examType),
        ]);
        response.then(axios.spread((topicResponse, assignedResponse, questionLimitResponse) => {
            let topics = topicResponse?.data?.topics;
            if (examType == 'COMBINED') {
                topics?.forEach(data => {
                    data.TempNoOfQuestion = data.NoOfQuestion;
                    data.NoOfQuestion = data.CombinedNoOfQuestion;
                })
                setCombinedGATopics(topics.filter(data => data.ExamType == 'GENERAL APTITUDE'))
            }
            let assignedQuestions = assignedResponse?.data?.assignedQuestions
            let questionLimit = questionLimitResponse?.data?.questionLimit
            setTopics(multiSortTopics(topics));
            setAssignedQuestions(assignedQuestions);
            setQuestionLimit(questionLimit);

        })).catch((error) => {
            console.log(error);
            toast.error(error.response?.data?.message || "An error occurred while fetching subjects and sections.");
        });
        return () => {
            setExamType('');
            setAssignedQuestions(0);
        };

    }, [modalBox, examType])

    useEffect(() => {
        if (examType == 'SUBJECT SPECIFIC' || examType == 'COMBINED') {
            axios.get(BACKEND_SERVER_URL + '/ugc/subjects/' + 'SUBJECT SPECIFIC').then((res) => {
                let subjects = res.data.subjects;
                let topicsWiseSubjects = subjects?.map(subject => {
                    let subjectTopics = topics?.filter(topic => topic.SubjectID === subject.Sn);

                    return {
                        ...subject,
                        topics: multiSortTopics(subjectTopics || []),
                        assignedQuestions: subjectTopics?.reduce((acc, curr) => acc + (curr?.NoOfQuestion ?? 0), 0)

                    }
                });
                let sortedTopicsWiseSubjects = sortInAlphabeticalOrder(topicsWiseSubjects, 'Subject');
                setSubjectToDisplay(sortedTopicsWiseSubjects[0]);
                setTopicsWiseSubjects(sortedTopicsWiseSubjects);
            }).catch((error) => {
                console.log(error);
                toast.error(error.response?.data?.message || "An error occurred while fetching subjects.");
            }
            )

        }
    }, [topics])

    const handleSaveTopic = async () => {
        try {
            let topicsToBeUpdated;
            if (examType !== 'COMBINED') {
                topicsToBeUpdated = examType == 'SUBJECT SPECIFIC' ? topicWiseSubjects?.flatMap(subject => subject.topics?.filter(topic => topic.isUpdated)) : topics?.filter(topic => topic.isUpdated);
            } else {
                topicsToBeUpdated = [...topicWiseSubjects?.flatMap(subject => subject.topics?.filter(topic => topic.isUpdated)), ...combinedGATopics?.filter(topic => topic.isUpdated)];
                topicsToBeUpdated = topicsToBeUpdated.map(data => {
                    return {
                        ...data,
                        CombinedNoOfQuestion: data.NoOfQuestion,
                        NoOfQuestion: data.TempNoOfQuestion
                    }
                })
            }



            if (topicsToBeUpdated.length == 0) {
                toast.info("No changes made to update");
                setModalBox(false);
                return;
            }


            const response = await axios.post(
                BACKEND_SERVER_URL + '/ugc/updateTestManagement/', topicsToBeUpdated?.map(data => ({ Sn: data.Sn, NoOfQuestion: data.NoOfQuestion, CombinedNoOfQuestion: data.CombinedNoOfQuestion, isUpdated: data.isUpdated || false }))
            );

            toast.success(response.data.message);
            props.setSubjectLoading(!props.loadSubjects);
            setModalBox(false);
        } catch (error) {
            console.error(error);
            toast.error(error?.response?.data?.message || "Something went wrong");
        }
    };


    const handleQCountChange = (Sn, value, SubjectID) => {
        console.log(SubjectID, Sn, value);
        value = Number(value);
        if (examType == 'SUBJECT SPECIFIC' || (examType == 'COMBINED' && selectedExam == 'SUBJECT SPECIFIC')) {
            let copy = [...topicWiseSubjects];
            let selectedSubject = copy.find((subject) => subject.Sn == SubjectID);
            let selectedToic = selectedSubject?.topics?.find((topic) => topic.Sn == Sn);
            // let preNumber = Number(selectedToic?.NoOfQuestion);
            // if (value > preNumber) {
            //     setAssignedQuestions(prev => prev + (value - preNumber));
            // } else if (value < preNumber) {
            //     setAssignedQuestions(prev => prev - (preNumber - value));
            // }
            selectedToic.NoOfQuestion = value;
            selectedToic.isUpdated = true;
            selectedSubject.assignedQuestions = selectedSubject.topics?.reduce((acc, curr) => acc + (curr?.NoOfQuestion ?? 0), 0);
            setTopicsWiseSubjects(copy);
        } else if (examType == 'COMBINED' && selectedExam == 'GENERAL APTITUDE') {
            let copy = [...combinedGATopics];
            let selectedToic = copy.find((topic, index) => topic.Sn == Sn);
            let preNumber = Number(selectedToic?.NoOfQuestion);
            if (value > preNumber) {
                setAssignedQuestions(prev => prev + (value - preNumber));
            } else if (value < preNumber) {
                setAssignedQuestions(prev => prev - (preNumber - value));
            }
            selectedToic.NoOfQuestion = value;
            selectedToic.isUpdated = true;
            setCombinedGATopics(multiSortTopics(copy));
        } else {
            let copy = [...topics];
            let selectedToic = copy.find((topic, index) => topic.Sn == Sn);
            let preNumber = Number(selectedToic?.NoOfQuestion);
            if (value > preNumber) {
                setAssignedQuestions(prev => prev + (value - preNumber));
            } else if (value < preNumber) {
                setAssignedQuestions(prev => prev - (preNumber - value));
            }
            selectedToic.NoOfQuestion = value;
            selectedToic.isUpdated = true;
            setTopics(multiSortTopics(copy));
        }

    }

    return (
        <Modal
            onHide={() => setModalBox(false)}
            show={modalBox}
            size="xl"
            backdrop="static"
            keyboard={false}
        >
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title">
                        Test Management
                    </h5>
                    <button type="button" className="btn-close" onClick={() => setModalBox(false)}></button>
                </div>

                <div className=" px-4 pb-0">
                    <div className="d-flex w-100 justify-content-between align-items-center mt-0 pt-0">
                        <div className="d-flex align-items-center gap-3">
                            <span className={`p-1 px-3 fw-bold text-white bg-primary fs-4 border border-2 rounded`}>{examType === "GENERAL APTITUDE" ? "Teaching & Research Aptitude" : examType === "SUBJECT SPECIFIC" ? "Academic Subjects" : examType === "COMBINED" ? "COMBINED TESTS" : examType}</span>
                        </div>
                        {
                            examType === "COMBINED" && (
                                <div className="d-flex justify-content-center gap-2 my-2">
                                    {["GENERAL APTITUDE", "SUBJECT SPECIFIC"].map((val) => (
                                        <div key={val}>
                                            <input
                                                type="radio"
                                                className="btn-check"
                                                name="exam-toggle"
                                                id={val}
                                                checked={selectedExam === val}
                                                onChange={() => setSelectedExam(val)}
                                            />
                                            <label
                                                className={`btn btn-sm px-3 py-1 rounded-pill fw-semibold shadow-sm ${selectedExam === val
                                                    ? "text-white border-0"
                                                    : "text-gray-700 border border-2 border-gray-300 bg-white"
                                                    }`}
                                                style={{
                                                    background: selectedExam === val
                                                        ? "linear-gradient(135deg, #06b6d4, #3b82f6)" // Teal → Blue gradient
                                                        : undefined,
                                                    transition: "all 0.2s ease-in-out"
                                                }}
                                                htmlFor={val}
                                            >
                                                {val === "GENERAL APTITUDE" ? "Teaching & Research Aptitude" : val === "SUBJECT SPECIFIC" ? "Academic Subjects" : val}
                                            </label>
                                        </div>
                                    ))}
                                </div>
                            )
                        }


                        {examType == 'SUBJECT SPECIFIC' || selectedExam == 'SUBJECT SPECIFIC' ?
                            <div className="mb-3 w-25">
                                {/* <label className="form-label text-primary">Subject<span className="required">*</span></label> */}
                                <Select
                                    value={subjectToDisplay?.Sn ? { value: subjectToDisplay, label: subjectToDisplay.Subject } : null}
                                    onChange={(opt) => setSubjectToDisplay(opt.value)}
                                    options={[...topicWiseSubjects].sort((a, b) => a.Subject?.localeCompare(b.Subject)).map(s => ({ value: s, label: s.Subject }))}
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            width: '100%',
                                            backgroundColor: 'transparent',
                                            borderColor: '#17a2b8',
                                        }),
                                    }}
                                    placeholder="Select Subject"
                                // isClearable
                                />
                            </div>
                            : null}
                        {
                            examType == 'SUBJECT SPECIFIC' || selectedExam == 'SUBJECT SPECIFIC' ? null :
                                <span className={`p-1 px-3 fw-bold text-white ${assignedQuestions == (examType == 'COMBINED' ? 50 : questionLimit) ? 'bg-success' : 'bg-danger'} fs-4 border border-2 rounded`}>Total Assigned Questions : {assignedQuestions}</span>
                        }
                        {/* {
                            (examType == 'COMBINED' && selectedExam == 'GENERAL APTITUDE') &&
                            <span className={`p-1 px-3 fw-bold text-white ${assignedQuestions == 50 ? 'bg-success' : 'bg-danger'} fs-4 border border-2 rounded`}>Total Questions : {assignedQuestions}</span>
                        } */}
                    </div>
                    {
                        (examType == 'GENERAL APTITUDE' || (examType == 'COMBINED' && selectedExam == 'GENERAL APTITUDE')) &&
                        <div className="d-flex w-100 justify-content-around mb-3">
                            <div className="mb-3  col-12">
                                <div className="table-responsive full-data" style={{ paddingBottom: "1px", transform: 'rotateX(180deg)' }}>
                                    <div id="example-student_wrapper" className="dataTables_wrapper no-footer">
                                        <table className="table-responsive-md table display dataTablesCard student-tab 
                                                                dataTable no-footer mt-0 mb-0" style={{ transform: 'rotateX(180deg)' }} id="example-student" >
                                            <thead style={{ backgroundColor: "#cccccc" }} >
                                                <tr className='text-center  border border-left'>
                                                    {/* <th className=' custom-table-header p-2'>SN</th> */}
                                                    <th className=' custom-table-header p-2 text-center'>SUBJECTS</th>
                                                    <th className=' custom-table-header p-2 text-center'>TOPICS</th>
                                                    <th className=' custom-table-header p-2  ps-3'>SUB TOPICS</th>
                                                    <th className=' custom-table-header p-2  ps-3'>Assigned Qs.</th>
                                                    <th className=' custom-table-header p-2  ps-3'>Available Qs.</th>

                                                </tr>
                                            </thead>
                                            <tbody>
                                                {(combinedGATopics.length > 0 ? combinedGATopics : topics)?.map((item, ind) => (
                                                    <tr key={ind} className={`${ind % 2 == 1 ? 'custom row-height' : 'row-height'}`} >


                                                        <td className='p-1' style={{ border: "1px solid #cccccc" }}>
                                                            <div className="d-flex justify-content-between ">
                                                                <h6 className='mb-0 ps-3' style={{ fontSize: '13px', fontWeight: 'bold' }}>{item.Subject}

                                                                </h6>
                                                            </div>
                                                        </td>
                                                        <td className='p-1' style={{ border: "1px solid #cccccc" }}>
                                                            <div className="d-flex justify-content-between ">
                                                                <h6 className='mb-0 ps-3' style={{ fontSize: '13px', fontWeight: 'bold' }}>{item.Section}

                                                                </h6>
                                                            </div>
                                                        </td>

                                                        <td className='p-1 text-start' style={{ border: "1px solid #cccccc" }}>
                                                            <h6 className="mb-0 ">
                                                                {item.Topic}
                                                            </h6>
                                                        </td>
                                                        <td className='p-1 text-center' style={{ border: "1px solid #cccccc", width: "65px" }}>
                                                            <input type="number" name={`${ind}questionCount`} className="form-control p-0 px-2" style={{ height: '1.75rem', lineHeight: '1.75rem', fontSize: '0.875rem' }} value={item?.NoOfQuestion ?? 0} min={0} onChange={(e) => handleQCountChange(item.Sn, e.target.value)} />

                                                        </td>
                                                        <td className='p-1 text-center' style={{ border: "1px solid #cccccc", width: "65px" }}>
                                                            <h6 className="mb-0 ">
                                                                {item.AvailableQuestions ?? 0}
                                                            </h6>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                            </div>
                        </div>
                    }
                    {
                        (examType == 'SUBJECT SPECIFIC' || selectedExam == 'SUBJECT SPECIFIC') &&
                        <div className="d-flex w-100 justify-content-around mb-3">
                            <div className="mb-3  col-12">
                                {topicWiseSubjects?.map((subject, index) => (
                                    subject.Sn == subjectToDisplay?.Sn ?
                                    <div className="d-flex justify-content-between align-items-center mb-2" key={`total-${index}`}>
                                        <h4 className="mb-0 fw-bold text-white bg-info p-1 rounded px-4 mt-1" style={{ fontSize: '1.25rem' }}>{subjectToDisplay.Subject}</h4>
                                        <span className={`px-3 py-1 rounded fw-bold border border-2 shadow-sm text-white ${subject.assignedQuestions == questionLimit - 50 ? 'bg-success' : 'bg-danger'}`}>
                                            Total Assigned Questions: {subject.assignedQuestions}
                                        </span>
                                    </div>
                                    : null
                                ))}
                                <div className="table-responsive full-data" style={{ paddingBottom: "1px", transform: 'rotateX(180deg)' }}>
                                    <div id="example-student_wrapper" className="dataTables_wrapper no-footer">
                                        <table className="table-responsive-md table display dataTablesCard student-tab 
                                                                dataTable no-footer mt-0 mb-0" style={{ transform: 'rotateX(180deg)' }} id="example-student" >
                                            <thead style={{ backgroundColor: "#cccccc" }} >
                                                <tr className='text-center  border border-left'>
                                                    {/* <th className=' custom-table-header p-2'>SN</th> */}
                                                    <th className=' custom-table-header p-2 text-center'>SUBJECTS</th>
                                                    <th className=' custom-table-header p-2 text-center'>TOPICS</th>
                                                    <th className=' custom-table-header p-2  ps-3'>SUB TOPICS</th>
                                                    <th className=' custom-table-header p-2  ps-3'>Assigned Qs.</th>
                                                    <th className=' custom-table-header p-2  ps-3'>Available Qs.</th>

                                                </tr>
                                            </thead>
                                            <tbody>
                                                {topicWiseSubjects?.map((subject, index) => {
                                                    return subject.Sn == subjectToDisplay?.Sn ?
                                                        <>
                                                            {
                                                                subject?.topics?.map((item, ind) => (
                                                                    <tr key={ind} className={`${ind % 2 == 1 ? 'custom  row-height' : 'row-height'}`} >
                                                                        <td className='p-1' style={{ border: "1px solid #cccccc" }}>
                                                                            <div className="d-flex justify-content-between ">
                                                                                <h6 className='mb-0 ps-3' style={{ fontSize: '13px', fontWeight: 'bold' }}>{item.Subject}

                                                                                </h6>
                                                                            </div>
                                                                        </td>
                                                                        <td className='p-1' style={{ border: "1px solid #cccccc" }}>
                                                                            <div className="d-flex justify-content-between ">
                                                                                <h6 className='mb-0 ps-3' style={{ fontSize: '13px', fontWeight: 'bold' }}>{item.Section}

                                                                                </h6>
                                                                            </div>
                                                                        </td>

                                                                        <td className='p-1 text-start' style={{ border: "1px solid #cccccc" }}>
                                                                            <h6 className="mb-0 ">
                                                                                {item.Topic}
                                                                            </h6>
                                                                        </td>
                                                                        <td className='p-1 text-center' style={{ border: "1px solid #cccccc", width: "65px" }}>
                                                                            <input type="number" name={`${ind}questionCount`} className="form-control p-0 px-2" style={{ height: '1.75rem', lineHeight: '1.75rem', fontSize: '0.875rem' }} value={item?.NoOfQuestion ?? 0} min={0} onChange={(e) => handleQCountChange(item.Sn, e.target.value, subject.Sn)} />

                                                                        </td>
                                                                        <td className='p-1 text-center' style={{ border: "1px solid #cccccc", width: "65px" }}>
                                                                            <h6 className="mb-0 ">
                                                                                {item.AvailableQuestions ?? 0}
                                                                            </h6>
                                                                        </td>
                                                                    </tr>
                                                                ))

                                                            }
                                                            <br />
                                                        </> : null


                                                }


                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                            </div>
                        </div>
                    }

                </div>

                <div className="modal-footer">
                    <button type="button" className="btn btn-danger btn-xs" onClick={() => setModalBox(false)}>Close</button>
                    <button type="button" className="btn btn-primary btn-xs" onClick={handleSaveTopic}>
                        Update / Save
                    </button>
                </div>
            </div>
        </Modal>
    );
});

export default UGC_TestManagementModal;
